import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22weight%22:%22900%22,%22style%22:%22normal%22,%22path%22:%22./fonts/ManukaCondensed/ManukaCondensed-Black.woff2%22}],%22variable%22:%22--font-manuka%22,%22fallback%22:[%22Impact%22,%22Helvetica%22,%22sans-serif%22],%22display%22:%22swap%22}],%22variableName%22:%22manuka%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'manuka', 'manuka Fallback', Impact, Helvetica, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
